"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sidebarUtils = _interopRequireDefault(require("../lib/sidebarUtils"));

var _orionContext = require("../orionContext/orionContext");

var _utils = require("../lib/utils");

require("./sidebar.css");

require("./msp-provider.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IS_MOBILE_BROWSER = (0, _utils.isMobileBrowser)();

var Sidebar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Sidebar, _React$Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Sidebar);
    _this = _super.call(this, props, context);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowResize", function () {
      var isTabletView = _this.state.isTabletView;

      var isTabletViewCur = _this.isLowerScreenWidth();

      if (isTabletViewCur !== isTabletView) {
        _this.setState({
          isTabletView: !isTabletView,
          isCollapsed: !isTabletView,
          isHoverable: !isTabletView
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSidebarMouseOver", function () {
      if (_this.innerRef.current.classList.contains("oui-sidebar-hoverable")) {
        _this.innerRef.current.classList.add("oui-is-hovering");
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSidebarMouseOut", function () {
      _this.innerRef.current.classList.remove("oui-is-hovering");
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isLowerScreenWidth", function () {
      return window.innerWidth < 992;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggle", function () {
      var isCollapsed = _this.state.isCollapsed;
      var _this$props = _this.props,
          onExpand = _this$props.onExpand,
          onCollapse = _this$props.onCollapse;

      if (isCollapsed) {
        _this.setState({
          isCollapsed: false,
          isHoverable: false
        }, function () {
          return (0, _setTimeout2["default"])(onExpand, 300);
        });
      } else {
        _this.setState({
          isCollapsed: true
        }, function () {
          (0, _setTimeout2["default"])(function () {
            _this.setState({
              isHoverable: true
            }, onCollapse);
          }, 500);
        });
      }
    });

    var isLowerScreenWidth = _this.isLowerScreenWidth();

    _this.state = {
      isCollapsed: props.collapsedByDefault || IS_MOBILE_BROWSER || isLowerScreenWidth,
      isHoverable: props.collapsedByDefault || IS_MOBILE_BROWSER || isLowerScreenWidth,
      isTabletView: IS_MOBILE_BROWSER || isLowerScreenWidth
    };
    _this.innerRef = /*#__PURE__*/_react["default"].createRef();
    _this.sidebarUtils = new _sidebarUtils["default"](context);
    _this.onWindowResize = (0, _utils.debounce)(_this.onWindowResize, 100);
    return _this;
  }

  (0, _createClass2["default"])(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var sidebar = this.innerRef.current;

      if (sidebar) {
        sidebar.addEventListener("mouseover", this.onSidebarMouseOver);
        sidebar.addEventListener("mouseout", this.onSidebarMouseOut);
      }

      if (!IS_MOBILE_BROWSER) {
        window.addEventListener("resize", this.onWindowResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var sidebar = this.innerRef.current;

      if (sidebar) {
        sidebar.removeEventListener("mouseover", this.onSidebarMouseOver);
        sidebar.removeEventListener("mouseout", this.onSidebarMouseOut);
      }

      if (!IS_MOBILE_BROWSER) {
        window.removeEventListener("resize", this.onWindowResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isCollapsed = _this$state.isCollapsed,
          isHoverable = _this$state.isHoverable,
          isTabletView = _this$state.isTabletView;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _utils.hasProperty)(this.props, "float") ? this.sidebarUtils.renderFloatingSidebar(this.props) : this.sidebarUtils.renderStaticSidebar(this.props, isCollapsed, isHoverable, this.toggle, isTabletView, this.innerRef));
    }
  }]);
  return Sidebar;
}(_react["default"].Component);

Sidebar.contextType = _orionContext.OrionContext;
Sidebar.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  sections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    heading: _propTypes["default"].string,
    component: _propTypes["default"].func,
    divider: _propTypes["default"].bool,
    className: _propTypes["default"].string
  })).isRequired,
  "float": _propTypes["default"].shape({
    direction: _propTypes["default"].oneOf(["left", "right"]),
    visible: _propTypes["default"].bool
  }),
  site: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    icon: _propTypes["default"].shape({
      src: _propTypes["default"].string,
      size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
      width: _propTypes["default"].string,
      height: _propTypes["default"].string,
      classes: _propTypes["default"].string,
      onClick: _propTypes["default"].func,
      className: _propTypes["default"].string
    }),
    circledIcon: _propTypes["default"].bool
  }),
  collapsible: _propTypes["default"].bool,
  collapsedByDefault: _propTypes["default"].bool,
  onCollapse: _propTypes["default"].func,
  onExpand: _propTypes["default"].func,
  className: _propTypes["default"].string,
  honourGlobalFooter: _propTypes["default"].bool,
  honourPageAlert: _propTypes["default"].bool,
  sidebarName: _propTypes["default"].string,
  footerLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string,
    target: _propTypes["default"].oneOf(["_blank", "_self", "_parent", "_top"]),
    renderComponent: _propTypes["default"].func
  })),
  dataTestId: _propTypes["default"].string
};
Sidebar.defaultProps = {
  honourGlobalFooter: false,
  honourPageAlert: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  sections: [],
  collapsible: false,
  collapsedByDefault: false,
  onCollapse: function onCollapse() {},
  onExpand: function onExpand() {},
  sidebarName: null,
  footerLinks: [],
  dataTestId: "orion-sidebar"
};
Sidebar.displayName = "OrionSidebar";
var _default = Sidebar;
exports["default"] = _default;